import {atom} from 'recoil';

export const stateSnackBar = atom({
    key: "snackbar",
    default: {
        open: false,
        type: "success",    // "error","info","success","warning"
        msg: "message"
    }
})